/// <amd-module name="typeahead/features/PostalCodeRequestParamModifier" />
/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../typings/typeahead/browser.d.ts" />
/// <reference path="../../typings/typeahead/plugins.d.ts" />
/// <reference path="../../typings/typeahead/ABTest.d.ts" />

import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";

const configuration: IStripingConfiguration[] = [{
    lobs: ["HOTELS", "CARS"],
}];

const featureFlag = "postal_code";
const postalCodeHotelBits = 32; // (postalCodeHotelBits >>> 0).toString(2) = 100000

export class PostalCodeRequestParamModifier implements IRequestUrlParamModifier {
    public modifyParameters(params: ISuggestServiceQueryParams, context: IContext, options?: any):
            JQueryPromise<ISuggestServiceQueryParams> {
        let deferred: JQueryDeferred<ISuggestServiceQueryParams> = $.Deferred();
        if (typeof params !== "undefined") {
            ExecutionHelper.shouldExecute(context, configuration)
                .done((shouldExecute) => {
                    params.features = params.features && params.features.length ? params.features || [] : [];
                    if (shouldExecute && params.features.indexOf(featureFlag) < 0) {
                        params.features.push(featureFlag);
                    }
                    if (shouldExecute && context.lob === "HOTELS") {
                        /* tslint:disable-next-line: no-bitwise */
                        params.mask |= postalCodeHotelBits;
                    }
                })
                .always(() => {
                    deferred.resolve(params);
                });
        } else {
            deferred.resolve(params);
        }
        return deferred.promise();
    }
}
